import Api from '.';

/**
 * Retrieve all HealthProfessionAssociationUF.
 */
export function listHealthProfessionAssociationUF() {
  return Api.get('/health-profession-association-uf');
}
